/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha15 = props => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 145"
    width="1em"
    height="1em"
    {...props}
  >
    <defs>
      <path
        d="M87.87 42.3S85.23 17.56 76.99 9.98c-8.25-7.59-24.9-6.93-24.9-6.93s-15.04-.96-21.28 5.28c-9.49 9.49-17.48 20.78-23.91 50.8-6.44 30.01 1.65 46.34 8.08 54.09s20.78 17.48 35.62 16.99c14.85-.5 21.36-2.74 36.78-19.96 14-18.13 6.6-46.18 5.28-49.97-1.32-3.79-3.83-14.38-4.79-17.98zM30.15 76.53c0-9.8 7.94-17.74 17.73-17.74s17.73 7.94 17.73 17.74c0 9.79-7.94 17.72-17.73 17.72s-17.73-7.93-17.73-17.72zm48.42-47.57c-1.17-1.32-7.04-7.94-17.59-19.86 9.38 10.59 15.25 17.21 17.59 19.86z"
        id="a"
      />
      <path
        d="M53.42 76.31c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.24-5 5-5 5 2.24 5 5z"
        id="b"
      />
    </defs>
    <use xlinkHref="#a" />
    <use xlinkHref="#a" fillOpacity={0} stroke="#000" strokeOpacity={0} />
    <g>
      <use xlinkHref="#b" />
    </g>
  </svg>
);
export default extendIcon(Deha15);
